// extracted by mini-css-extract-plugin
module.exports = {"formTitleContainer":"Amenities_formTitleContainer__3gwhB","formItemContainer":"Amenities_formItemContainer__2jf6_","formItem":"Amenities_formItem__31HKq"};